module.exports = "#map-holder\r\n{   \r\n    z-index: 9;\r\n    padding: 0;\r\n    height: 500px;\r\n    max-width:none;\r\n}\r\n\r\n#map-wrapper\r\n{\r\n    overflow: hidden;\r\n    height: 70%;\r\n}\r\n\r\n#map-wrapper * {\r\n    overflow:visible;\r\n}\r\n\r\n.card-padrao\r\n{\r\n    max-width: 720px; \r\n    margin: 0 auto;\r\n}\r\n\r\n.label-toggle-especifico\r\n{\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.btn-form-pesquisa\r\n{\r\n    width: 170px;\r\n    margin: 0 20px 0 20px;\r\n}\r\n\r\ninput, select {text-transform: uppercase;}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/pesquisa/pesquisa.component.css
 ** module id = 470
 ** module chunks = 0
 **/